export default "__VITE_ASSET__C$zTUY93__"